import { render, staticRenderFns } from "./HalloffameMain.vue?vue&type=template&id=4ee62c94&"
import script from "./HalloffameMain.vue?vue&type=script&lang=js&"
export * from "./HalloffameMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports